const STORAGE_KEY = "wedding-uploader-token";

/**
 * Anonymous per-browser identifier, generated once and persisted in
 * localStorage. Sent with every upload and included when listing/deleting
 * media, so the server can tell "this guest's own sends" apart from
 * everyone else's without any account system.
 */
export function getUploaderToken(): string {
  let token = localStorage.getItem(STORAGE_KEY);
  if (!token) {
    token = crypto.randomUUID();
    localStorage.setItem(STORAGE_KEY, token);
  }
  return token;
}
